import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white p-4">
      <div className="container mx-auto text-center">
        <p>&copy; 2025 Study Material Tracking. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
